var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Sidebar/SidebarNavItem.vue?vue&type=template&id=0ffc4245&
// module id = null
// module chunks = 